"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Carousel, _React$Component);

  function Carousel() {
    var _this;

    (0, _classCallCheck2["default"])(this, Carousel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Carousel).call(this));
    _this.state = {
      currentIndex: 0
    };
    _this.autoScrollTimer = undefined;
    _this.getDisplayItemIndicies = _this.getDisplayItemIndices.bind((0, _assertThisInitialized2["default"])(_this));
    _this.changeCurrentIndex = _this.changeCurrentIndex.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          autoScroll = _this$props.autoScroll,
          autoScrollTime = _this$props.autoScrollTime;

      if (autoScroll) {
        this.autoScrollTimer = setInterval(function () {
          return _this2.incrementCurrentIndex();
        }, autoScrollTime);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.autoScrollTimer) {
        clearInterval(this.autoScrollTimer);
      }
    }
  }, {
    key: "setCurrentIndex",
    value: function setCurrentIndex(index) {
      var totalNumberOfItems = this.props.totalNumberOfItems;
      this.setState({
        currentIndex: index % totalNumberOfItems
      });
    }
  }, {
    key: "getDisplayItemIndices",
    value: function getDisplayItemIndices() {
      var _this$props2 = this.props,
          numberOfDisplayItems = _this$props2.numberOfDisplayItems,
          totalNumberOfItems = _this$props2.totalNumberOfItems;
      var currentIndex = this.state.currentIndex;
      var displayIndices = new Array(numberOfDisplayItems).fill(currentIndex).map(function (i, index) {
        return (i + index) % totalNumberOfItems;
      });
      return displayIndices;
    }
  }, {
    key: "changeCurrentIndex",
    value: function changeCurrentIndex(index) {
      var totalNumberOfItems = this.props.totalNumberOfItems;

      if (index < 0) {
        this.setCurrentIndex(totalNumberOfItems - 1);
      } else if (index === totalNumberOfItems) {
        this.setCurrentIndex(0);
      } else {
        this.setCurrentIndex(index);
      }
    }
  }, {
    key: "incrementCurrentIndex",
    value: function incrementCurrentIndex() {
      var currentIndex = this.state.currentIndex;
      this.setCurrentIndex(currentIndex + 1);
    }
  }, {
    key: "render",
    value: function render() {
      var currentIndex = this.state.currentIndex;
      var children = this.props.children;
      var childProps = {
        currentIndex: currentIndex,
        getDisplayItemIndices: this.getDisplayItemIndicies,
        changeCurrentIndex: this.changeCurrentIndex
      };
      return children(childProps);
    }
  }]);
  return Carousel;
}(_react["default"].Component);

exports["default"] = Carousel;
Carousel.propTypes = {
  totalNumberOfItems: _propTypes["default"].number.isRequired,
  autoScroll: _propTypes["default"].bool,
  autoScrollTime: _propTypes["default"].number,
  numberOfDisplayItems: _propTypes["default"].number
};
Carousel.defaultProps = {
  autoScroll: false,
  autoScrollTime: 3000,
  numberOfDisplayItems: 3
};